import React from 'react';

const StockInvestors: React.FC = () => {
  return (
    <div className="stock-investors">
      <h3>투자자 정보</h3>
    </div>
  );
};

export default StockInvestors;
